<div class="row">
  <div class="col-md-7 border-right-solid pe-50px pt-4">    
    <div class="d-flex align-items-center mb-3">
            <h6 class="loginHeadingText text-start mt-0 me-2 mb-0">INSTRUCTIONS</h6>
            <a (click)="showReminderDialog()">
                <img src="assets/images/mail_icon.png" alt="email" class="emailicon" title="Send Reminder Email">
            </a>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="mb-3 mt-4">
          <label for="" class="mb-1">Upload Only PDF Files</label>
          <div class="input-group custom-file-button">

            <!-- <input type="file" class="form-control" id="inputGroupFile"> -->
               <!-- [selFiles]="selectedInstructionsVM?.files || []"  -->
                  <!-- [selectedFiles]="selectedFiles" -->
                    <!-- [selectedFiles]="selectedFiles" -->
                    <!-- [selFiles]="selectedInstructionsVM?.files || []" -->
                     
            <app-flexible-file-upload [inputFIleID]="'instFile'"
                                      [disableControl]="disableFields"
                                      [selFiles]="selFiles"
                                      [acceptedFileTypes]="'.pdf'"
                                      [showAdditionalInfo]="false"
                                      [allowMultipleFiles]="true"
                                      [disableAfterReview]="disableFields"
                                      (fileUploaded)="handleFileUpload($event)"
                                      (multipleFileDelete)="deleteFile($event)"
                                      
                                      >
            </app-flexible-file-upload>
          </div>
        </div>


        <!-- <div class="row">
          <div class="col-md-1 pe-0">
            <img src="assets/images/close_mark.svg" alt="">
          </div>
          <div class="col-md-8 ps-0">
            <a href="#" class="fw-bold ms-2" style="color:#0c9ef1; text-decoration: none;">Instruction 1.pdf</a>
          </div>
          <div class="col-md-3 text-end">
            <p class="mb-0">(90)</p>
          </div>
        </div> -->
      </div>
      <div class="col-md-4 mb-3 mt-5">
        <label class=""></label>
      </div>
      
      <!-- <div class="col-md-7">
        <h6 class="searchByText mt-4">SELECT A TEMPLATE OR UPLOAD INSTRUCTION FILE</h6>
        <div class="row" [ngClass]="{'disabled-row': false}">
          <div class="col-md-4">
            <div class="form-check form-check-inline mb-2">
              <input class="form-check-input" type="radio" name="templateone" id="inlineRadio1" data-bs-toggle="modal" data-bs-target="#staticBackdrop" value="1" [checked]="templateOne" (change)="onTemplateChange($event);">
              <label class="form-check-label" for="inlineRadio1">Template 1</label>
            </div>
            <div class="row">
              <img src="assets/images/temp_1.png" class="img-fluid" alt="" style="width: 169px; cursor: pointer;" data-bs-toggle="modal" data-bs-target="#staticBackdrop" (click)="selectTemplateOne();">
            </div>
          </div>
          <div class="col-md-4 ps-1">
            <div class="form-check form-check-inline mb-2">
              <input class="form-check-input" type="radio" name="templateone" id="inlineRadio2" data-bs-toggle="modal" data-bs-target="#staticBackdrop_two" value="2  " [(ngModel)]="templateId">
              <label class="form-check-label" for="inlineRadio2">Template 2</label>
            </div>


            <div class="row">
              <div class="col-md-12">
                <img src="assets/images/temp_3.png" class="img-fluid" alt="" style="width: 158px; cursor: pointer;" data-bs-toggle="modal" data-bs-target="#staticBackdrop_two">
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-check form-check-inline mb-2">
              <input class="form-check-input" type="radio" name="templateone" id="inlineRadio3" data-bs-toggle="modal" data-bs-target="#staticBackdrop_three" value="3" [(ngModel)]="templateId">
              <label class="form-check-label" for="inlineRadio3">Template 3</label>
            </div>
            <div class="row">
              <div class="col-md-12">
                <img src="assets/images/temp_4.png" class="img-fluid" alt="" style="width: 151px; cursor: pointer;" data-bs-toggle="modal" data-bs-target="#staticBackdrop_three">
              </div>
            </div>
          </div>
        </div>
      </div> -->


      <div class="col-md-1 text-center">
        <!-- <h6 class="orText mt-4">OR</h6> -->
      </div>
  
    </div>
  </div>

  <div class="col-md-5 ps-50px pt-4 pb-2">
    <label for="" class="mb-1 pt-0"><span class="text-dark">TOOLS</span> (If Additional Tools Required)</label>
    <textarea class="form-control imgInfo_2 mb-4" name="" id="" cols="30" rows="10"
              [disabled]="disableFields" (ngModelChange)="onAnyFieldValueChange($event)"
              [(ngModel)]="selectedInstructionsVM!.tools">      
    </textarea>

    <label for="" class="mb-1"><span class="text-dark">NOTES</span> (Additional Instructions – if any) </label>
    <textarea class="form-control imgInfo_2 mb-4" name="" id="" cols="30" rows="10"
              [disabled]="disableFields" (ngModelChange)="onAnyFieldValueChange($event)"
              [(ngModel)]="selectedInstructionsVM!.notes">
    </textarea>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style="top:45px;">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header py-2">
        <h1 class="modal-title modalTitle" id="staticBackdropLabel">TEMPLATE 1</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancel();"></button>
      </div>
      <div class="modal-body pb-2">
        <div class="row mb-2">
          <div class="col-md-8">
            <h6 class="searchByText ">DRAG & DROP IMAGES AND TYPE IN YOUR INSTRUCTIONS</h6>
          </div>
          <div class="col-md-4 text-end">
            <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"></a>
          </div>
        </div>
        <div class="row pb-3">
          <div class="col-md-12">

            <div class="NgxEditor__Wrapper" style="margin-bottom: 20px;">
              <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar"></ngx-editor-menu>
              <div class="ngx-editor-content-wrapper">
                <ngx-editor [editor]="editor1" [(ngModel)]="instructionTextHtml11" [disabled]="false" [placeholder]="'Enter Instructions'"></ngx-editor>
              </div>
            </div>


          </div>
          <div class="col-md-6">

            <!--<div class="drogdroupbox h-160"
                 (dragenter)="handleDragEnter()"
                 (dragleave)="handleDragLeave()"
                 (drop)="handleDrop($event,11)"
                 [class.loaded]="imageLoaded"
                 [style.outlineColor]="dragging ? activeColor : baseColor"
                 ondragover="return false;">
              <i class="icon icon-upload glyphicon glyphicon-upload"
                 [style.color]="dragging
                 ? ((instructionImagesVm.length>
                0) ? overlayColor : activeColor)
                : ((instructionImagesVm.length > 0) ? overlayColor : baseColor)">
              </i>
              <img src="../../../../../assets/images/img_drog.svg" *ngIf="!imageLoaded && imageId != 11" alt="">
              <div *ngFor="let img of instructionImagesVm;  let i = index;">
                <img src="assets/images/close_icon.svg" class="closeButton" alt="" *ngIf="img.imageID == 11" (click)="onDeleteInstructionImageFile(i)">
                <img [src]="img.base64Bytes" class="imgupload"
                     (load)="handleImageLoad()"
                     [class.loaded]="imageLoaded" *ngIf="img.imageID == 11" />
              </div>
              <input type="file" name="file" accept="image/*"
                     (change)="handleInputChange($event,11)"
                     style="display: none;" />
            </div>-->

            <div class="drogdroupbox h-160"
                 (click)="fileInput11.click()"
                 (dragenter)="handleDragEnter()"
                 (dragleave)="handleDragLeave()"
                 (drop)="handleDrop($event, 11)"
                 [class.loaded]="imageLoaded"
                 [style.outlineColor]="dragging ? activeColor : baseColor"
                 ondragover="return false;">
              <i class="icon icon-upload glyphicon glyphicon-upload"
                 [style.color]="dragging
                 ? ((instructionImagesVm.length>
                0) ? overlayColor : activeColor)
                : ((instructionImagesVm.length > 0) ? overlayColor : baseColor)">
              </i>
              <img src="../../../../../assets/images/img_drog.svg" *ngIf="!imageLoaded && imageId != 11" alt="">
              <div *ngFor="let img of instructionImagesVm; let i = index;">
                <img src="assets/images/close_icon.svg" class="closeButton" alt="" *ngIf="img.imageID == 11"
                     (click)="onDeleteInstructionImageFile(i); $event.stopPropagation()">
                <img [src]="img.base64Bytes" class="imgupload"
                     (load)="handleImageLoad()"
                     [class.loaded]="imageLoaded" *ngIf="img.imageID == 11" (click)="$event.stopPropagation()" />
              </div>
              <input #fileInput11 type="file" name="file" accept="image/*"
                     (change)="handleInputChange($event, 11)"
                     style="display: none;" />
            </div>

          </div>


          <div class="col-md-6">

            <!--<div class="drogdroupbox h-160"
       (dragenter)="handleDragEnter()"
       (dragleave)="handleDragLeave()"
       (drop)="handleDrop($event,12)"
       [class.loaded]="imageLoaded"
       [style.outlineColor]="dragging ? activeColor : baseColor"
       ondragover="return false;">
    <i class="icon icon-upload glyphicon glyphicon-upload"
       [style.color]="dragging
       ? ((instructionImagesVm.length>
      0) ? overlayColor : activeColor)
      : ((instructionImagesVm.length > 0) ? overlayColor : baseColor)">
    </i>

    <div *ngFor="let img of instructionImagesVm;  let i = index;">
      <img src="assets/images/close_icon.svg" class="closeButton" alt="" *ngIf="img.imageID == 12" (click)="onDeleteInstructionImageFile(i)">
      <img [src]="img.base64Bytes" class="imgupload"
           (load)="handleImageLoad()"
           [class.loaded]="imageLoaded" *ngIf="img.imageID == 12" />
      <input type="file" name="file" accept="image/*"
             (change)="handleInputChange($event,12)"
             style="display: none;" />
    </div>
    <img src="../../../../../assets/images/img_drog.svg" *ngIf="!imageLoaded && imageId != 12" alt="">
  </div>-->

            <div class="drogdroupbox h-160"
                 (click)="fileInput12.click()"
                 (dragenter)="handleDragEnter()"
                 (dragleave)="handleDragLeave()"
                 (drop)="handleDrop($event, 12)"
                 [class.loaded]="imageLoaded"
                 [style.outlineColor]="dragging ? activeColor : baseColor"
                 ondragover="return false;">
              <i class="icon icon-upload glyphicon glyphicon-upload"
                 [style.color]="dragging
                 ? ((instructionImagesVm.length>
                0) ? overlayColor : activeColor)
                : ((instructionImagesVm.length > 0) ? overlayColor : baseColor)">
              </i>
              <img src="../../../../../assets/images/img_drog.svg" *ngIf="!imageLoaded && imageId != 12" alt="">
              <div *ngFor="let img of instructionImagesVm; let i = index;">
                <img src="assets/images/close_icon.svg" class="closeButton" alt="" *ngIf="img.imageID == 12"
                     (click)="onDeleteInstructionImageFile(i); $event.stopPropagation()">
                <img [src]="img.base64Bytes" class="imgupload"
                     (load)="handleImageLoad()"
                     [class.loaded]="imageLoaded" *ngIf="img.imageID == 12" (click)="$event.stopPropagation()" />
              </div>
              <input #fileInput12 type="file" name="file" accept="image/*"
                     (change)="handleInputChange($event, 12)"
                     style="display: none;" />
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button class="btn progressBtn ps-2" role="button" (click)="templateOneFinalData()" data-bs-dismiss="modal" aria-label="Close">
            ADD TO PROJECT
          </button>
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
          <button class="btn progressBtn ps-2" role="button" (click)="exportAsPDF()">
            PREVIEW PDF FILE
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="staticBackdrop_two" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdrop_twoLabel" aria-hidden="true" style="top:45px;">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header py-2">
        <h1 class="modal-title modalTitle" id="staticBackdrop_twoLabel">TEMPLATE 2</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-2">
        <div class="row mb-2">
          <div class="col-md-8">
            <h6 class="searchByText ">DRAG & DROP IMAGES AND TYPE IN YOUR INSTRUCTIONS</h6>
          </div>
          <div class="col-md-4 text-end">
            <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"></a>
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-md-4 mb-15px">

            <div class="drogdroupbox" style="height:300px;"
                 (dragenter)="handleDragEnter()"
                 (dragleave)="handleDragLeave()"
                 (drop)="handleDrop($event,21)"
                 [class.loaded]="imageLoaded"
                 [style.outlineColor]="dragging ? activeColor : baseColor"
                 ondragover="return false;">
              <i class="icon icon-upload glyphicon glyphicon-upload"
                 [style.color]="dragging
                 ? ((instructionImagesVm.length>
                0) ? overlayColor : activeColor)
                : ((instructionImagesVm.length > 0) ? overlayColor : baseColor)">
              </i>

              <div *ngFor="let img of instructionImagesVm">
                <img [src]="img.base64Bytes" class="imgupload"
                     (load)="handleImageLoad()"
                     [class.loaded]="imageLoaded" *ngIf="img.imageID == 21" />
                <input type="file" name="file" accept="image/*"
                       (change)="handleInputChange($event,21)"
                       style="display: none;" />
              </div>
              <img src="../../../../../assets/images/img_drog.svg" *ngIf="!imageLoaded && imageId != 21" alt="">
            </div>
          </div>
          <div class="col-md-8 ps-2 mb-15px">

            <div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor2" [toolbar]="toolbar"></ngx-editor-menu>
              <div class="ngx-editor-content-wrapper">
                <ngx-editor [editor]="editor2" [(ngModel)]="instructionTextHtml21" [disabled]="false" [placeholder]="'Enter Instructions'"></ngx-editor>
              </div>
            </div>
          </div>


          <div class="col-md-4 mb-15px">

            <div class="drogdroupbox" style="height:300px;"
                 (dragenter)="handleDragEnter()"
                 (dragleave)="handleDragLeave()"
                 (drop)="handleDrop($event,22)"
                 [class.loaded]="imageLoaded"
                 [style.outlineColor]="dragging ? activeColor : baseColor"
                 ondragover="return false;">
              <i class="icon icon-upload glyphicon glyphicon-upload"
                 [style.color]="dragging
                 ? ((instructionImagesVm.length>
                0) ? overlayColor : activeColor)
                : ((instructionImagesVm.length > 0) ? overlayColor : baseColor)">
              </i>

              <div *ngFor="let img of instructionImagesVm">
                <img [src]="img.base64Bytes" class="imgupload"
                     (load)="handleImageLoad()"
                     [class.loaded]="imageLoaded" *ngIf="img.imageID == 22" />
                <input type="file" name="file" accept="image/*"
                       (change)="handleInputChange($event,22)"
                       style="display: none;" />
              </div>
              <img src="../../../../../assets/images/img_drog.svg" *ngIf="!imageLoaded && imageId != 22" alt="">
            </div>
          </div>
          <div class="col-md-8 ps-2 mb-15px">
            <!--<textarea class="form-control imgInfo" placeholder="Enter Instructions" name="" id="" cols="30" rows="10"></textarea>-->

            <div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor3" [toolbar]="toolbar"></ngx-editor-menu>
              <div class="ngx-editor-content-wrapper">
                <ngx-editor [editor]="editor3" [(ngModel)]="instructionTextHtml22" [disabled]="false" [placeholder]="'Enter Instructions'"></ngx-editor>
              </div>
            </div>
          </div>


          <div class="col-md-4">

            <div class="drogdroupbox" style="height:300px;"
                 (dragenter)="handleDragEnter()"
                 (dragleave)="handleDragLeave()"
                 (drop)="handleDrop($event,23)"
                 [class.loaded]="imageLoaded"
                 [style.outlineColor]="dragging ? activeColor : baseColor"
                 ondragover="return false;">
              <i class="icon icon-upload glyphicon glyphicon-upload"
                 [style.color]="dragging
                 ? ((instructionImagesVm.length>
                0) ? overlayColor : activeColor)
                : ((instructionImagesVm.length > 0) ? overlayColor : baseColor)">
              </i>
              <!--*ngIf="imageId == 1 && imageId ! = 2"-->

              <div *ngFor="let img of instructionImagesVm">
                <img [src]="img.base64Bytes" class="imgupload"
                     (load)="handleImageLoad()"
                     [class.loaded]="imageLoaded" *ngIf="img.imageID == 23" />
                <input type="file" name="file" accept="image/*"
                       (change)="handleInputChange($event,23)"
                       style="display: none;" />
              </div>
              <img src="../../../../../assets/images/img_drog.svg" *ngIf="!imageLoaded && imageId != 23" alt="">
            </div>

          </div>
          <div class="col-md-8 ps-2 ">

            <div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor4" [toolbar]="toolbar"></ngx-editor-menu>
              <div class="ngx-editor-content-wrapper">
                <ngx-editor [editor]="editor4" [(ngModel)]="instructionTextHtml23" [disabled]="false" [placeholder]="'Enter Instructions'"></ngx-editor>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
        <button class="btn progressBtn ps-2" role="button">
          PREVIEW PDF FILE
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="staticBackdrop_three" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdrop_threeLabel" aria-hidden="true" style="top:45px;">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header py-2">
        <h1 class="modal-title modalTitle" id="staticBackdrop_threeLabel">TEMPLATE 3</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-2">
        <div class="row mb-2">
          <div class="col-md-8">
            <h6 class="searchByText ">DRAG &amp; DROP IMAGES AND TYPE IN YOUR INSTRUCTIONS</h6>
          </div>
          <div class="col-md-4 text-end">
            <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"></a>
          </div>
        </div>
        <div class="row mb-1 pb-2">
          <div class="col-md-6">
            <div class="drogdroupbox h-160">
              <img src="../../../../../assets/images/img_drog.svg" alt="">
            </div>
          </div>
          <div class="col-md-6">
            <!--<textarea class="form-control imgInfo mb-4 h-159" placeholder="Enter Instructions"></textarea>-->

            <div class="NgxEditor__Wrapper" style="height: 340px; margin-bottom:20px">
              <ngx-editor-menu [editor]="editor5" [toolbar]="toolbar"></ngx-editor-menu>
              <div class="ngx-editor-content-wrapper">
                <ngx-editor [editor]="editor5" [(ngModel)]="instructionTextHtml31" [disabled]="false" [placeholder]="'Enter Instructions'"></ngx-editor>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="drogdroupbox h-160">
              <img src="../../../../../assets/images/img_drog.svg" alt="">
            </div>
          </div>
          <div class="col-md-3">
            <div class="drogdroupbox h-160">
              <img src="../../../../../assets/images/img_drog.svg" alt="">
            </div>
          </div>
          <div class="col-md-6">

            <div class="NgxEditor__Wrapper" style="height: 340px; margin-bottom:20px">
              <ngx-editor-menu [editor]="editor6" [toolbar]="toolbar"></ngx-editor-menu>
              <div class="ngx-editor-content-wrapper">
                <ngx-editor [editor]="editor6" [(ngModel)]="instructionTextHtml32" [disabled]="false" [placeholder]="'Enter Instructions'"></ngx-editor>
              </div>
            </div>
          </div>

          <div class="col-md-12">

            <div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor7" [toolbar]="toolbar"></ngx-editor-menu>
              <div class="ngx-editor-content-wrapper">
                <ngx-editor [editor]="editor7" [(ngModel)]="instructionTextHtml33" [disabled]="false" [placeholder]="'Enter Instructions'"></ngx-editor>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">

        <button class="btn progressBtn ps-2" role="button">
          PREVIEW PDF FILE
        </button>
      </div>
    </div>
  </div>
</div>

<div id="MyDIv" class="main-container">

</div>
